import { lazy, type FC } from 'react';
import { useHydrogenFcfsLeadTimeSettings } from 'src/apis/hydrogen-fcfs/use-hydrogen-fcfs-lead-time-settings';
import { useHydrogenFcfsRootLink } from 'src/apis/hydrogen-fcfs/use-hydrogen-fcfs-root';
import { useHydrogenFcfsSettings } from 'src/apis/hydrogen-fcfs/use-hydrogen-fcfs-settings';
import { PageSpinner } from 'src/components/spinner-container';

const Page = lazy(() => import('./page'));

export const HydrogenFcfsSettings: FC = () => {
  const hydrogenFcfsSettingsUrl = useHydrogenFcfsRootLink(
    'organisationFcfsSettings'
  );
  const hydrogenFcfsSettings = useHydrogenFcfsSettings(hydrogenFcfsSettingsUrl);
  const hydrogenFcfsLeadTimeSettingsUrl = useHydrogenFcfsRootLink(
    'organisationFcfsLeadTimeSettings'
  );
  const hydrogenFcfsLeadTimeSettings = useHydrogenFcfsLeadTimeSettings(
    hydrogenFcfsLeadTimeSettingsUrl
  );

  if (
    !hydrogenFcfsSettings.response ||
    (hydrogenFcfsLeadTimeSettings && !hydrogenFcfsLeadTimeSettings.response)
  )
    return <PageSpinner />;
  return (
    <Page
      hydrogenFcfsSettings={hydrogenFcfsSettings}
      hydrogenFcfsLeadTimeSettings={hydrogenFcfsLeadTimeSettings}
    />
  );
};
